export default __webpack_public_path__ + "static/005-539ccc3ab056cc34188e25a34d22cb3b.jpg";